import PropTypes from 'prop-types';

import { fieldTypes } from './constants';

export const FieldTypePropTypeName = PropTypes.oneOf(Object.values(fieldTypes));

export const FieldTypePropType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  name: FieldTypePropTypeName.isRequired,
  description: PropTypes.string.isRequired,
});

export const FieldPropType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  orderNum: PropTypes.number.isRequired,
  type: FieldTypePropType.isRequired,
  value: PropTypes.string.isRequired,
});
